import { formatCurrencyValue } from '@vend/utilities'
import {
  useRetailerSettingsManager,
  useRegisterManager,
} from '../../../ng-compat/hooks'

/**
 * Hook to conveniently format a currency value using retailer & active outlet currency settings
 * @returns (value: number | string) => string
 */
export const useFormatCurrencyValue = () => {
  const retailer = useRetailerSettingsManager().get()
  const activeOutlet = useRegisterManager().getActiveOutlet()

  return (value: number | string) =>
    formatCurrencyValue(
      value,
      retailer.culture,
      activeOutlet.currency,
      activeOutlet.currency_symbol
    )
}
